import { FormEventHandler } from "react";

type LoginPageViewProps = {
  email: string;
  password: string;
  loading: boolean;
  errorText: string | null;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onSubmit: FormEventHandler<HTMLFormElement>;
};

export default function LoginPageView({
  email,
  password,
  loading,
  errorText,
  onEmailChange,
  onPasswordChange,
  onSubmit,
}: LoginPageViewProps): JSX.Element {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #0a1628 0%, #0e2a3a 60%, #0d3347 100%)",
      padding: "1.5rem",
    }}>
      <div style={{
        width: "100%",
        maxWidth: "400px",
        background: "white",
        borderRadius: "16px",
        boxShadow: "0 24px 64px rgba(0,0,0,.35)",
        padding: "2.5rem 2rem",
      }}>
        {/* Logo + wordmark */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "2rem" }}>
          <img src="/VerityEdge_Favicon.png" alt="" width="44" height="44" style={{ borderRadius: "10px", marginBottom: ".6rem" }} />
          <img src="/VerityEdge_Logo.png" alt="Verity Edge" height="20" style={{ objectFit: "contain", marginBottom: ".2rem" }} />
          <span style={{ fontSize: ".78rem", color: "#64748b", marginTop: ".2rem" }}>Audit-grade edge evidence</span>
        </div>

        <h1 style={{ margin: "0 0 .25rem", fontSize: "1.2rem", fontWeight: 700, textAlign: "center" }}>Sign in to your dashboard</h1>
        <p style={{ margin: "0 0 1.5rem", color: "#64748b", fontSize: ".82rem", textAlign: "center" }}>
          Use your operator credentials.
        </p>

        <form onSubmit={onSubmit} style={{ display: "grid", gap: ".875rem" }}>
          <label style={{ display: "grid", gap: ".35rem" }}>
            <span style={{ fontSize: ".82rem", fontWeight: 600, color: "#374151" }}>Email</span>
            <input
              type="email"
              name="email"
              autoComplete="email"
              value={email}
              onChange={(event) => onEmailChange(event.target.value)}
              required
              placeholder="operator@company.eu"
              style={{
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                padding: ".65rem .8rem",
                font: "inherit",
                fontSize: ".9rem",
                outline: "none",
                transition: "border-color .15s",
              }}
              onFocus={e => { e.currentTarget.style.borderColor = "var(--brand, #0e7490)"; }}
              onBlur={e => { e.currentTarget.style.borderColor = "#d1d5db"; }}
            />
          </label>

          <label style={{ display: "grid", gap: ".35rem" }}>
            <span style={{ fontSize: ".82rem", fontWeight: 600, color: "#374151" }}>Password</span>
            <input
              type="password"
              name="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => onPasswordChange(event.target.value)}
              required
              placeholder="••••••••"
              style={{
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                padding: ".65rem .8rem",
                font: "inherit",
                fontSize: ".9rem",
                outline: "none",
                transition: "border-color .15s",
              }}
              onFocus={e => { e.currentTarget.style.borderColor = "var(--brand, #0e7490)"; }}
              onBlur={e => { e.currentTarget.style.borderColor = "#d1d5db"; }}
            />
          </label>

          {errorText ? (
            <div role="alert" style={{
              padding: ".6rem .8rem",
              borderRadius: "8px",
              background: "#fee2e2",
              border: "1px solid #fca5a5",
              color: "#991b1b",
              fontSize: ".82rem",
              fontWeight: 500,
            }}>
              {errorText}
            </div>
          ) : null}

          <button
            type="submit"
            disabled={loading}
            style={{
              background: "var(--brand, #0e7490)",
              color: "white",
              border: "none",
              borderRadius: "8px",
              padding: ".7rem 1rem",
              cursor: loading ? "default" : "pointer",
              opacity: loading ? 0.75 : 1,
              fontWeight: 700,
              fontSize: ".9rem",
              marginTop: ".25rem",
              transition: "opacity .15s",
            }}
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div style={{ marginTop: "1.5rem", paddingTop: "1rem", borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "center", gap: "1.25rem" }}>
          <a href="mailto:contact@verityedge.eu" style={{ fontSize: ".75rem", color: "#94a3b8", textDecoration: "none" }}>Support</a>
          <a href="https://verityedge.eu/trust/known-limits" style={{ fontSize: ".75rem", color: "#94a3b8", textDecoration: "none" }}>Known limits</a>
          <a href="https://verityedge.eu/" style={{ fontSize: ".75rem", color: "#94a3b8", textDecoration: "none" }}>Marketing site</a>
        </div>
      </div>
    </div>
  );
}
